<template>
  <el-submenu
    v-if="item.type == 'MENU'"
    :index="item.id"
    popper-class="micro-left-menu-pop-box"
  >
    <template slot="title">
      <img
        v-if="menuIcon.type === 'url'"
        :src="menuIcon.value"
        class="menu-icon-img"
      />
      <img
        v-else-if="menuIcon.type === 'local'"
        :src="getLocalIcon(menuIcon.value)"
        class="menu-icon-img"
      />
      <span slot="title" class="name">{{ item.name }}</span>
    </template>
    <IteraMenu v-for="child in item.children" :key="child.id" :item="child" />
  </el-submenu>
  <el-menu-item v-else :index="item.url" @click="goPage(item)">
    <img
      v-if="menuIcon.type === 'url'"
      :src="menuIcon.value"
      class="menu-icon-img"
    />
    <img
      v-else-if="menuIcon.type === 'local'"
      :src="getLocalIcon(menuIcon.value)"
      class="menu-icon-img"
    />
    <span slot="title" class="name">
      {{ item.name }}
    </span>
  </el-menu-item>
</template>

<script>
import { mapState } from 'vuex'
import microApp from '@micro-zoe/micro-app'
import { parseMenuIcon } from '@/utils/index'
export default {
  name: 'IteraMenu',
  props: ['item'],
  computed: {
    ...mapState('app', ['appMenu']),
    menuIcon() {
      return parseMenuIcon(this.item.resourceIcon)
    }
  },
  methods: {
    getLocalIcon(iconName) {
      try {
        return require(`@/assets/icon/${iconName}`)
      } catch (e) {
        return ''
      }
    },
    goPage(item) {
      if (this.$route.meta.type == 'INNER_APP') {
        this.$router.push({
          path: `/${item.url}`
        })
      } else if (this.$route.meta.type == 'MICRO_APP') {
        if (item.type == 'MODULE') {
          if (item.url?.includes('http')) {
            window.open(item.url, '_blank')
          } else {
            window.open(`/${this.$route.meta.context}/${item.url}`, '_self')
          }
        } else {
          microApp.router.push({
            name: this.$route.meta.context,
            path: `/${this.$route.meta.context}/${item.url}`,
            replace: true
          })
        }
      }
    },
    getUrlPathById(data, targetId) {
      const findMenuItem = (items) => {
        for (const item of items) {
          if (item.id === targetId) {
            return item
          }
          if (item.children) {
            const found = findMenuItem(item.children)
            if (found) {
              return found
            }
          }
        }
        return null
      }

      const item = findMenuItem(data)
      if (!item) {
        return ''
      }

      const pathParts = []
      let current = item
      while (current) {
        pathParts.unshift(current.url)
        const parent = data.find((p) => p.id === current.parentId)
        current = parent
      }

      return '/' + this.$route.meta.context + '/' + pathParts.join('/')
    }
  }
}
</script>
<style lang="scss" scoped>
.menu-icon-img {
  width: 14px;
  height: 14px;
  margin-right: 8px;
  vertical-align: middle;
}
</style>
